import type { RouteRecordRaw } from 'vue-router'
import { PERMISSIONS } from '@/core/permissions/constants'

export const orchestrationRoutes: RouteRecordRaw[] = [
  {
    path: '/orchestration',
    name: 'orchestration-features',
    component: () => import('@/modules/orchestration/views/FeaturesListView.vue'),
    meta: {
      requiresAuth: true,
      permission: PERMISSIONS.ORCHESTRATION.VIEW,
    },
  },
  {
    path: '/orchestration/:id',
    name: 'orchestration-feature-detail',
    component: () => import('@/modules/orchestration/views/FeatureDetailView.vue'),
    meta: {
      requiresAuth: true,
      permission: PERMISSIONS.ORCHESTRATION.VIEW,
    },
  },
]
